import {apiClient} from '../api/apiClient';
import {useCallback, useRef} from "react";

export const useTrackVisit = () => {
    const visited = useRef(new Set<string>());

    return useCallback((page: string) => {
        if (visited.current.has(page)) return;
        visited.current.add(page);
        apiClient.post('/visits', { page }).catch(() => {});
    }, []);
};
